<template>
    <section v-if="isEu" class="disclaimerContainer">
        <div class="popupBox">
            <h1>
                Importance Notice
            </h1>
            <p>
                We have detected that you are accessing this website from a location within the European Union (EU).
                Please note that this website is operated by an entity that is not regulated in the EU. If you are an EU
                resident, you must access our EU-regulated entity <a href="https://www.doofinancial.eu/">website</a>, of
                Doo Financial Cyprus Ltd, which is
                authorised by the Cyprus Securities and Exchange Commission (CySEC) under License No. 448/24
            </p>
            <p>
                Transacting with a non-EU entity may result in a loss of investor protections available under EU laws
                and regulations.
            </p>
            <p class="disclaimer">
                <span>Disclaimer:</span> This website is operated by a company outside the European Union and is not
                regulated under
                EU law. EU clients are advised to use our regulated European entity, Doo Financial Cyprus Ltd,
                authorised by CySEC, to ensure full investor protection.
            </p>
            <a class="proceed" @click="closePopup()">Proceed</a>
        </div>
    </section>
</template>

<script setup>
import { getLocation } from '@/api/location';
import { ref, onMounted, onUnmounted } from 'vue';
import { useI18n } from 'vue-i18n';

// const ImageUrl = "https://doo-prime-static.oss-cn-hongkong.aliyuncs.com/doo/aufc/"

const { t } = useI18n();

const euCountries = ["DE", "PL", "AT", "PT", "IT", "LU", "CZ", "CY", "BE", "BG", "HR", "DK", "EE", "FI", "FR", "GR", "HU", "IE",
    "LV", "LT", "MT", "NL", "RO", "SK", "SI", "ES", "SE",
    "IS", "LI", "NO"]

let isEu = ref(false)

async function checkEu() {
    const location = await getLocation()
    let countryCode = location.data.country_code;
    // let countryCode = "SE"
    if (euCountries.includes(countryCode)) {
        isEu.value = true;
    }
}

function closePopup() {
    isEu.value = false;
}

onMounted(() => {
    checkEu();
})

</script>

<style lang="less">
.disclaimerContainer {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 100000000000;
    background-color: #666666;
    display: flex;
    margin: auto;
    padding: 16px;

    .popupBox {
        max-width: 600px;
        padding: 48px 48px 32px;
        border-radius: 16px;
        box-shadow: rgba(0, 0, 0, 0.1) 0px 3px 11px 0px;
        background-color: rgb(255, 255, 255);
        display: flex;
        flex-direction: column;
        z-index: 1;
        transform: scale(1);
        transition: transform 0.15s ease-out;
        margin: auto;

        h1 {
            margin: 0 0 24px;
            font-size: 32px;
            font-weight: bold;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.13;
            letter-spacing: normal;
            text-align: left;
            color: #000;
        }

        p {
            font-size: 16px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.44;
            letter-spacing: normal;
            text-align: left;
            color: #000;
            margin-top: 15px;
        }

        .disclaimer {
            font-size: 14px;
            font-style: italic;
        }

        span {
            font-weight: bold;
            text-decoration: underline;
        }

        .proceed {
            margin-top: 24px;
            display: flex;
            justify-content: center;
            width: 146px;
            margin-top: 32px;
            padding: 10px 0 11px;
            border-radius: 8px;
            background-color: #e51c1c !important;
            font-size: 20px;
            font-weight: 600;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.75;
            letter-spacing: normal;
            text-align: center;
            color: #fff !important;
            cursor: pointer;
            align-self: flex-end;
        }
    }
}

@import '@/less/mediaQuery.less';
@tablet-screen: ~"only screen and (max-width:1050px)";
</style>